import { render, staticRenderFns } from "./interactionPlansComponent.vue?vue&type=template&id=6135ef82&scoped=true&"
import script from "./interactionPlansComponent.vue?vue&type=script&lang=js&"
export * from "./interactionPlansComponent.vue?vue&type=script&lang=js&"
import style0 from "./interactionPlansComponent.vue?vue&type=style&index=0&id=6135ef82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6135ef82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDivider,VRow,VTextField})
